import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthModule } from './views/pages/auth/auth.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { ConfirmMailComponent } from './core/auth/confirm-mail/confirm-mail.component';
import { AdminVerificationComponent } from './core/auth/admin-verification/admin-verification.component';
import { UserBlockedComponent } from './core/auth/user-blocked/user-blocked.component';
import { SubmitLectureStudentsComponent } from './submit-lecture/submit-lecture-students.component';
import { SubmitLectureAdultsComponent } from './submit-lecture/submit-lecture-adults.component';
import { MigrateLecturesComponent } from './migration/migrate-lectures/migrate-lectures.component';
import { MigrateUsersProgressComponent } from './migration/migrate-users-progress/migrate-users-progress.component';

export function HttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient);
}

const routes: Routes = [
  { path: '', loadChildren: () => AuthModule },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'lectures',
        loadChildren: () => import('./views/pages/lectures/lectures.module').then(m => m.LecturesModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./views/pages/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'apps',
        loadChildren: () => import('./views/pages/apps/apps.module').then(m => m.AppsModule)
      },
      {
        path: 'ui-components',
        loadChildren: () => import('./views/pages/ui-components/ui-components.module').then(m => m.UiComponentsModule)
      },
      {
        path: 'advanced-ui',
        loadChildren: () => import('./views/pages/advanced-ui/advanced-ui.module').then(m => m.AdvancedUiModule)
      },
      {
        path: 'form-elements',
        loadChildren: () => import('./views/pages/form-elements/form-elements.module').then(m => m.FormElementsModule)
      },
      {
        path: 'advanced-form-elements',
        // tslint:disable-next-line:max-line-length
        loadChildren: () => import('./views/pages/advanced-form-elements/advanced-form-elements.module').then(m => m.AdvancedFormElementsModule)
      },
      {
        path: 'charts-graphs',
        loadChildren: () => import('./views/pages/charts-graphs/charts-graphs.module').then(m => m.ChartsGraphsModule)
      },
      {
        path: 'tables',
        loadChildren: () => import('./views/pages/tables/tables.module').then(m => m.TablesModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/pages/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'general',
        loadChildren: () => import('./views/pages/general/general.module').then(m => m.GeneralModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./views/pages/general/profile.module').then(m => m.ProfileModule)
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      // { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  {path: '404', component: ErrorPageComponent},
  {path: 'confirm-mail', component: ConfirmMailComponent},
  {path: 'admin-verification', component: AdminVerificationComponent},
  {path: 'user-blocked', component: UserBlockedComponent},
  {path: 'submit-lecture-students', component: SubmitLectureStudentsComponent},
  {path: 'submit-lecture-adults', component: SubmitLectureAdultsComponent},
  {path: 'update-user-progress', component: MigrateUsersProgressComponent},
  // {path: 'migration', component: MigrateLecturesComponent},
  // {path: 'modify', component: ModifyLecturesComponent},
  {path: '**', redirectTo: '/404'}
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' }),
            ReactiveFormsModule,
            TranslateModule.forRoot({
              loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
              }
            }),
            SharedModule.forRoot()],
  exports: [RouterModule, TranslateModule]
})
export class AppRoutingModule { }
